import React, { useState, useEffect } from 'react';
import {
    Container,
    Paper,
    Typography,
    Button,
    Grid,
    Box,
    Alert,
    CircularProgress,
    Collapse,
    TextField
} from '@mui/material';
import '../styles/AccountSettings.css';
import Lottie from 'react-lottie';
import profileAnimation from '../animations/anime5.json';

const AccountSettings = () => {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [showPasswordForm, setShowPasswordForm] = useState(false);

    const [profileData, setProfileData] = useState({
        name: localStorage.getItem('userName') || '',
        email: localStorage.getItem('userEmail') || '',
        phone: '',
        profileImage: ''
    });

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const animationOptions = {
        loop: true,
        autoplay: true,
        animationData: profileAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    useEffect(() => {
        // Kullanıcı bilgilerini çek
        fetchUserData();
    }, []);

    const fetchUserData = async () => {
        try {
            const userEmail = localStorage.getItem('userEmail');
            //const token = localStorage.getItem('token');

            const response = await fetch(`${process.env.REACT_APP_API_URL}/students/getByEmail/${userEmail}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },


            });

            if (!response.ok) {
                throw new Error('Kullanıcı bilgileri alınamadı');
            }

            const data = await response.json();
            setProfileData(prev => ({
                ...prev,
                name: data.firstName + " " + data.lastName || '',
                email: data.email || '',
                phone: data.phone || '',
                profileImage: data.profileImage || ''
            }));
        } catch (error) {
            setError('Kullanıcı bilgileri alınamadı');
        }
    };
/*
    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            const response = await fetch(`${process.env.REACT_APP_API_URL}/students/${userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    name: profileData.name,
                    email: profileData.email,
                    phone: profileData.phone,
                    profileImage: profileData.profileImage
                })
            });

            if (response.ok) {
                const updatedUser = await response.json();
                setSuccess('Profil bilgileri başarıyla güncellendi');
                localStorage.setItem('userName', updatedUser.name);
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Profil güncellenirken bir hata oluştu');
            }
        } catch (error) {
            setError('Bir hata oluştu');
        } finally {
            setLoading(false);
        }
    };
*/
    const handlePasswordUpdate = async (e) => {
        e.preventDefault();

        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setError('Yeni şifreler eşleşmiyor');
            return;
        }

        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    currentPassword: passwordData.currentPassword,
                    newPassword: passwordData.newPassword
                })
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess('Şifre başarıyla güncellendi');
                setPasswordData({
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                });
            } else {
                setError(data.message || 'Şifre güncellenirken bir hata oluştu');
            }
        } catch (error) {
            setError('Bir hata oluştu, lütfen daha sonra tekrar deneyin');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="account-settings-container">
            <Typography variant="h4" className="page-title">
                Hesap Ayarları
            </Typography>



            <Grid container spacing={4} alignItems="center" style={{ marginTop: '20px', marginBottom: '20px' }}>
                {/* Sol taraf - Animasyon */}
                <Grid item xs={12} md={6} className="animation-container">
                    <Lottie
                        options={animationOptions}
                        height={400}
                        width={400}
                    />
                </Grid>

                {/* Sağ taraf - Kullanıcı Bilgileri */}
                <Grid item xs={12} md={6}>
                    <Paper elevation={3} className="profile-paper">
                        <Box className="profile-info">
                            <Typography variant="h6" className="info-label">Ad Soyad</Typography>
                            <Typography variant="body1" className="info-value">{profileData.name.toUpperCase()}</Typography>

                            <Typography variant="h6" className="info-label">E-posta</Typography>
                            <Typography variant="body1" className="info-value">{profileData.email}</Typography>

                            <Typography variant="h6" className="info-label">Telefon</Typography>
                            <Typography variant="body1" className="info-value">{profileData.phone || '-'}</Typography>

                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => setShowPasswordForm(!showPasswordForm)}
                                className="password-toggle-button"
                            >
                                {showPasswordForm ? 'Şifre Formunu Gizle' : 'Şifre Değiştir'}
                            </Button>

                            <Collapse in={showPasswordForm}>
                                <form onSubmit={handlePasswordUpdate} className="password-form">
                                    <TextField
                                        fullWidth
                                        type="password"
                                        label="Mevcut Şifre"
                                        value={passwordData.currentPassword}
                                        onChange={(e) => setPasswordData({...passwordData, currentPassword: e.target.value})}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        type="password"
                                        label="Yeni Şifre"
                                        value={passwordData.newPassword}
                                        onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        type="password"
                                        label="Yeni Şifre (Tekrar)"
                                        value={passwordData.confirmPassword}
                                        onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})}
                                        margin="normal"
                                    />
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        disabled={loading}
                                        className="submit-button"
                                        style={ {marginBottom: '10px'} }
                                    >
                                        {loading ? <CircularProgress size={24} /> : 'Şifreyi Güncelle'}
                                    </Button>
                                    {error && <Alert severity="error" className="alert">{error}</Alert>}
                                    {success && <Alert severity="success" className="alert">{success}</Alert>}
                                </form>
                            </Collapse>
                        </Box>
                    </Paper>
                </Grid>

            </Grid>

        </Container>
    );
};

export default AccountSettings;
